module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_2-95fc9a9992a65a4c5089460e013a707b.jpg";